import { LocalStorage } from '../../../../shared/utils';
import localization from '../../../../shared/strings';
import Logger from '../../../../services/Logger';
import { showDialog } from '../../../dialog';
import { showUpdateSharedAltTextDialog } from '../UpdateSharedAltTextDialog';

export const UPDATE_SHARED_ALT_SKIP_KEY = 'picsio.updateSharedAltTextDontShow';

export const confirmSharedAltUpdate = ({
  productTitle,
  affectedUsages,
  onConfirm,
  onCancel,
}) => {
  if (LocalStorage.get(UPDATE_SHARED_ALT_SKIP_KEY)) {
    Logger.log('User', 'ProductsSharedMediaAltConfirmed', { action: 'update', skippedDialog: true });
    onConfirm();
    return;
  }

  showUpdateSharedAltTextDialog({
    productTitle,
    affectedUsages,
  })
    .then((dontShowAgain) => {
      if (dontShowAgain) {
        LocalStorage.set(UPDATE_SHARED_ALT_SKIP_KEY, true);
      }

      Logger.log('User', 'ProductsSharedMediaAltConfirmed', { action: 'update' });
      onConfirm();
    })
    .catch((error) => {
      if (error?.message === 'cancel') {
        onCancel?.();
      }
    });
};

export const confirmSharedAltClear = ({
  productTitle,
  onConfirm,
  onCancel,
}) => {
  const strings = localization.ALT_TEXT.CLEAR_SHARED;

  showDialog({
    title: strings.TITLE,
    text: strings.TEXT(productTitle),
    textBtnOk: strings.BTN_OK,
    textBtnCancel: strings.BTN_CANCEL,
    onOk: () => {
      Logger.log('User', 'ProductsSharedMediaAltConfirmed', { action: 'clear' });
      onConfirm();
    },
    onCancel,
  });
};
